<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<p class="center"><img alt="" src="OEBPS/images/5-1.png"/></p>
<p class="pagebreak"> </p>
<h1 class="chapter1" id="toc"><em>Contents</em></h1>
<p class="toc"><a class="hlink" href="#/OEBPS/cvi.htm">Cover</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ack.htm">Acknowledgments</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/int.htm">Introduction</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c01.htm">Anniversaries</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c02.htm">Valentine’s Day</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c03.htm">Love &amp; Friendship</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c04.htm">Special Birthdays</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c05.htm">New Home</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c06.htm">Weddings &amp; Commitment</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c07.htm">Exams &amp; Graduation</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c08.htm">Across the Miles</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c09.htm">Birthdays</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c10.htm">New Baby</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c11.htm">Sorry</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c12.htm">Christmas &amp; New Year</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c13.htm">Thank You</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c14.htm">Easter &amp; Religious</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c15.htm">Christenings</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c16.htm">Mother’s Day</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c17.htm">Father’s Day</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c18.htm">Good Luck &amp; New Job</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c19.htm">Get Well</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c20.htm">Divorce &amp; Sympathy</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c21.htm">Invitations</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c22.htm">Miscellaneous</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/sup.htm">Suppliers</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/ata.htm">About the Author</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/cop.htm">Copyright</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?39d12109